module.exports = __webpack_public_path__ + "static/media/man-looking-down.ffc6689e.png";